const fonts = {
    titleXL: {
        lineHeight: '1',
        fontSize: '60px',
        fontWeight: '800',
    },
    titleL: {
        lineHeight: '1.2',
        fontSize: '30px',
        fontWeight: '800',
    },
    titleM: {
        lineHeight: '1.2',
        fontSize: '16px',
        fontWeight: '800',
    },
    titleCustomField: {
        lineHeight: '1.2',
        fontSize: '20px',
        fontWeight: '800',
    },
    subtitle: {
        lineHeight: '1.2',
        fontSize: '14px',
        fontWeight: '500',
    },
    text: {
        lineHeight: '1.2',
        fontSize: '14px',
        fontWeight: '500',
    },
    input: {
        lineHeight: 'auto',
        fontSize: '16px',
        fontWeight: '400',
    },
    normal: {
        lineHeight: '20px',
        fontSize: '14px',
        fontWeight: '400',
    },
    button: {
        lineHeight: '28px',
        fontSize: '18px',
        fontWeight: '600',
    },
};

export default fonts;
